//importing the web3
import Web3 from "web3";

window.web3 = new Web3(window.xdc);
const web3 = new Web3(window.xdc);

export default web3;